import { useRoomContext } from "@livekit/components-react"
import { Track } from "livekit-client"
import { useSelector } from "react-redux"

/**
 * Returns the LiveKit camera track when in a live session,
 * or null otherwise. Used by CameraComponent to attach the
 * video stream for scan capture.
 *
 * Note: returns a track even when the camera is muted/disabled
 * (the publication exists but the track is paused). Do NOT use
 * this to check if the camera is actively on — use
 * useLocalParticipant().isCameraEnabled for that.
 */
export function useLiveCameraTrack() {
    const room = useRoomContext()
    const isLiveModeEnabled = useSelector(
        (state) => state.liveMode?.isLiveModeEnabled
    )
    return isLiveModeEnabled
        ? (room?.localParticipant?.getTrackPublication(Track.Source.Camera)
              ?.track ?? null)
        : null
}
